var map = {
	"./bird.jpg": 48132,
	"./boy 01.jpg": 32246,
	"./boy 02.jpg": 2593,
	"./boy.jpg": 56315,
	"./boy1.jpg": 89414,
	"./dol 1.jpg": 87029,
	"./dol 2.jpg": 46538,
	"./dol.jpg": 13744,
	"./school boy 1.jpg": 10158,
	"./smal lion.jpg": 61246,
	"./teddy.jpg": 87731
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9903;